import { render } from "./CustomerRecordList.vue?vue&type=template&id=24d48607"
import script from "./CustomerRecordList.vue?vue&type=script&lang=js"
export * from "./CustomerRecordList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/common/basedata/partner/customerRecords/CustomerRecordList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24d48607"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24d48607', __exports__)) {
    api.reload('24d48607', __exports__)
  }
  
  module.hot.accept("./CustomerRecordList.vue?vue&type=template&id=24d48607", () => {
    api.rerender('24d48607', render)
  })

}


export default __exports__